// src/context/FavouriteContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";
import { AuthContext } from "./AuthContext";

const FavouriteContext = createContext();

export const FavouriteProvider = ({ children }) => {
	const { user } = useContext(AuthContext);
	// console.log("userkflh", user)
	const [favourites, setFavourites] = useState([]);

	// Function to fetch favourites from the backend
	const refreshFavourites = async () => {
		if (user && user.id) {
			try {
				const res = await fetch("/.netlify/functions/get-favourites", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ userId: user.id }),
				});
				if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
				const data = await res.json();
				// console.log("data.favourites", data.favourites);
				setFavourites(data.favourites || []);
			} catch (error) {
				console.error("Error refreshing favourites:", error);
			}
		} else {
			// If no user is logged in, clear favourites
			setFavourites([]);
		}
	};

	// Fetch favourites when user changes
	useEffect(() => {
		refreshFavourites();
	}, [user]);

	// Optimistic update function to toggle a favourite property
	const toggleFavourite = async (propertyId) => {
		let newFavourites;
		if (favourites.includes(propertyId)) {
			newFavourites = favourites.filter((id) => id !== propertyId);
		} else {
			newFavourites = [...favourites, propertyId];
		}
		// Optimistically update the UI:
		setFavourites(newFavourites);

		try {
			const res = await fetch("/.netlify/functions/update-favourites", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ userId: user.id, propertyId }),
			});
			if (!res.ok) throw new Error("Failed to update favourites");
			// Optionally, revalidate from server:
			// await refreshFavourites();
		} catch (error) {
			console.error("Error updating favourites:", error);
			// Roll back optimistic update by re-fetching the data
			await refreshFavourites();
		}
	};

	return (
		<FavouriteContext.Provider
			value={{ favourites, refreshFavourites, toggleFavourite }}
		>
			{children}
		</FavouriteContext.Provider>
	);
};

export const useFavourites = () => useContext(FavouriteContext);
